import {
  getAppDetailApi,
  updateRouterApi,
} from "./views/routerManage/routerEdit/service";
import { util_api } from "./libs/util_api.js";
// 用户流程
const flowNodeUserApi = [
  { name: "通过审核", path: "user_flow_node_user/pass" },
  { name: "批量通过审核", path: "user_flow_node_user/batch_pass" },
  { name: "驳回审核", path: "user_flow_node_user/fail" },
  { name: "邀请审批", path: "user_flow_node_user/invite" },
  { name: "转移流程", path: "user_flow_node_user/transfer" },
  { name: "批量转移流程", path: "user_flow_node_user/batch_transfer" },
  { name: "hold流程", path: "user_flow_node_user/hold" },
  { name: "查询流程", path: "user_flow_node_user/query" },
  { name: "查询流程详情", path: "user_flow/detail" },
  { name: "查询流程基本信息", path: "user_flow/base" },
  { name: "添加抄送人", path: "user_flow/add_link_user" },
  { name: "查询用户", path: "customer/select_search" },
  {
    name: "查询用户摘要信息（头像，昵称，组织架构，email）",
    path: "customer/brief",
  },
];

const flowBasicApiList = [
  ...flowNodeUserApi,
  { name: "查询人员信息，包括team", path: "customer/query_with_team" },
  { name: "废弃支出", path: "expense_group/delete" },
  { name: "查询流程model", path: "flow/get_by_link_model" },
  { name: "查询供货商", path: "payee_company_account/select_search" },
];

const contractApi = [
  { name: "contract_save", path: "contract/save" },
  { name: "query_contract", path: "contract/query" },
  { name: "contract_legal_audit_users", path: "contract/legal_audit_users" },
  { name: "get_contract_brief", path: "contract/brief_info" },
  { name: "es_query_contract", path: "contract/es_query" },
  { name: "search_contract", path: "contract/search" },
  { name: "contract_select_search", path: "contract/select_search" },
  { name: "query_finished_contract", path: "contract/query_finished" },
  { name: "query_mine_contract", path: "contract/query_mine" },
  { name: "es_query_mine_contract", path: "contract/es_query_mine" },
  { name: "query_contract_need_pay", path: "contract/query_need_pay" },
  {
    name: "contract_noticed_finishing_list",
    path: "contract/noticed_finishing_list",
  },
  { name: "contract_detail", path: "contract/detail" },
  { name: "find_contract", path: "contract/find" },
  { name: "update_contract", path: "contract/update" },
  { name: "delete_contract", path: "contract/delete" },
  { name: "close_contract", path: "contract/close" },
  { name: "close_outsource_contract", path: "outsource_contract/close" },
  { name: "contract_add_e_file_audit", path: "contract/add_e_file_audit" },
  { name: "delete_link_contract", path: "contract/delete_link_contract" },
  { name: "update_contract_files", path: "contract/update_files" },
  { name: "contract_sync_to_kingdee", path: "contract/sync_to_kingdee" },
  {
    name: "contract_update_need_at_payment_audit",
    path: "contract/update_need_at_payment_audit",
  },
  { name: "contract_bill_generate_type", path: "contract/bill_generate_type" },
  { name: "contract_check_add_payment", path: "contract/check_add_payment" },
  {
    name: "contract_related_placing_records",
    path: "contract/related_placing_records",
  },
  {
    name: "contract_delete_placing_record",
    path: "contract/delete_placing_record",
  },
  {
    name: "contract_save_placing_record",
    path: "contract/save_placing_record",
  },
  { name: "export_contract", path: "export/contract" },
];

const outSourceContractApi = [
  { name: "close_outsource_contract", path: "outsource_contract/close" },
  { name: "query_outsource_contract", path: "outsource_contract/query" },
  {
    name: "query_my_outsource_contract",
    path: "outsource_contract/query_mine",
  },
  {
    name: "outsource_contract_select_search",
    path: "outsource_contract/select_search",
  },
  { name: "find_outsource_contract", path: "outsource_contract/find" },
  {
    name: "update_outsource_wage_record_bank_info",
    path: "outsource_wage_record/update_bank_info",
  },
  {
    name: "query_my_valid_outsource_contract",
    path: "outsource_contract/my_valid_contract",
  },
  {
    name: "query_my_expired_outsource_contract",
    path: "outsource_contract/my_expired_contract",
  },
  { name: "update_outsource_contract", path: "outsource_contract/update" },
  { name: "delete_outsource_contract", path: "outsource_contract/delete" },
  { name: "outsource_contract_detail", path: "outsource_contract/detail" },
  {
    name: "outsource_contract_sign_remind",
    path: "outsource_contract/sign_remind",
  },
  {
    name: "outsource_payee_company_account",
    path: "outsource_contract/payee_company_account",
  },
  {
    name: "update_outsource_contract_archive_files",
    path: "outsource_contract/update_archive_files",
  },
  {
    name: "outsource_contract_need_clear",
    path: "outsource_contract/need_clear",
  },
  {
    name: "outsource_contract_save_final_contract",
    path: "outsource_contract/save_final_contract",
  },
  {
    name: "outsource_contract_contract_revoke",
    path: "outsource_contract/contract_revoke",
  },
  {
    name: "outsource_contract_contract_sign",
    path: "outsource_contract/contract_sign",
  },
  { name: "export_outsource_contract", path: "export/outsource_contract" },
  {
    name: "outsource_contract_related_placing_records",
    path: "outsource_contract/related_placing_records",
  },
  {
    name: "outsource_contract_delete_placing_record",
    path: "outsource_contract/delete_placing_record",
  },
  {
    name: "outsource_contract_save_placing_record",
    path: "outsource_contract/save_placing_record",
  },
];

const expenseGroupPageApi = [
  { name: "查询支出列表", path: "expense_group/es_query_mine" },
  { name: "查询支出类型", path: "expense_type/used_last_generation_types" },
  { name: "查询外包合同", path: "outsource_contract/select_search" },
  { name: "查询普通付款合同", path: "contract/select_search" },
  { name: "查询投放记录", path: "placing_ads_record/select_search" },
  { name: "保存付款申请", path: "expense_group/save" },
];

/* ------------------------------------------  薪酬系统相关api  --------------------------------------- */
// 薪酬系统-薪酬管理-产研正式
const paySystemXCCY = [
  { name: "查询列表", path: util_api.customer_basic_salary_info_page },
  { name: "个体历史薪酬", path: util_api.customer_basic_salary_history_list },
  { name: "调整薪资", path: util_api.customer_salary_adjust_apply_save },
  {
    name: "个体社保公积金详情",
    path: util_api.customer_basic_salary_info_detail,
  },
  {
    name: "个体公积金调整记录",
    path: util_api.customer_basic_salary_insurance_change_history,
  },
  {
    name: "编辑个体社保公积金",
    path: util_api.customer_basic_salary_save_insurance_change_info,
  },
  {
    name: "下载模板",
    path: util_api.customer_basic_salary_init_import_template,
  },
  { name: "导入", path: util_api.customer_basic_salary_import_basic_salary },
];
const paySystemXCCYConfig = {
  routeName: ["人事", "薪酬系统", "薪酬管理", "产研-正式"],
  apiList: paySystemXCCY,
};

//薪酬系统-薪酬管理-餐补设置
const paySystemCBSZ = [
  { name: "获取数据", path: util_api.customer_meal_subsidy_list },
  { name: "编辑数据", path: util_api.customer_meal_subsidy_update },
];
const paySystemCBSZConfig = {
  routeName: ["人事", "薪酬系统", "薪酬管理", "餐补设置"],
  apiList: paySystemCBSZ,
};

// 薪酬系统-薪酬管理-缴存基数
const paySystemJCJS = [
  { name: "获取数据", path: util_api.customer_insurance_payment_base_get_base },
  {
    name: "编辑数据",
    path: util_api.customer_insurance_payment_base_update_base,
  },
];
const paySystemJCJSConfig = {
  routeName: ["人事", "薪酬系统", "薪酬管理", "缴存基数"],
  apiList: paySystemJCJS,
};

// 薪酬系统-薪酬管理-缴存比例
const paySystemJCBL = [
  {
    name: "获取数据",
    path: util_api.customer_insurance_payment_ratio_get_ratio,
  },
  {
    name: "编辑数据",
    path: util_api.customer_insurance_payment_ratio_update_ratio,
  },
];

const paySystemJCBLConfig = {
  routeName: ["人事", "薪酬系统", "薪酬管理", "缴存比例"],
  apiList: paySystemJCBL,
};
// 薪酬系统-薪酬管理-经常性支付
const paySystemJCXZF = [
  {
    name: "保存",
    path: util_api.often_payment_save,
  },
  {
    name: "列表",
    path: util_api.often_payment_list,
  },
  {
    name: "删除",
    path: util_api.often_payment_del,
  },
];

const paySystemJCXZFConfig = {
  routeName: ["人事", "薪酬系统", "薪酬管理", "经常性支付"],
  apiList: paySystemJCXZF,
};

// 薪酬系统-薪资发放-产研-正式
const paySystemXZFFCYZSCommon = [
  {
    name: "数据汇总",
    path: util_api.customer_month_salary_total_company_month_salary_info,
  },
  { name: "详情列表", path: util_api.customer_month_salary_total_detail_list },
  {
    name: "初始化数据模版",
    path: util_api.customer_month_salary_total_down_init_template_file,
  },
  {
    name: "初始化数据导入",
    path: util_api.customer_month_salary_total_import_init_data,
  },
  {
    name: "导出结果",
    path: util_api.customer_month_salary_total_download_detail,
  },
];
const paySystemXZFFCYZS = [
  { name: "获取计薪周期列表", path: util_api.customer_month_salary_total_list },
  {
    name: "导入具体周期数据",
    path: util_api.customer_month_salary_total_import_salary_detail_info,
  },
  {
    name: "具体周期数据模版",
    path: util_api.customer_month_salary_total_down_import_templete,
  },
  { name: "归档", path: util_api.customer_month_salary_total_pigeonhole },
  { name: "同步cbs", path: util_api.customer_month_salary_total_pay_salary },
  {
    name: "导入工资条",
    path: util_api.customer_month_salary_total_transfer_wage,
  },
  { name: "撤回", path: util_api.customer_salary_payment_apply_delete },
  ...paySystemXZFFCYZSCommon,
];

const paySystemXZFFCYZSConfig = {
  routeName: ["人事", "薪酬系统", "薪资发放", "产研-正式"],
  apiList: paySystemXZFFCYZS,
};

// 薪酬系统-薪酬流程-单人调薪
const paySystemXCLCDRTX = [
  { name: "列表", path: util_api.customer_salary_adjust_apply_search },
  { name: "详情", path: util_api.customer_salary_adjust_apply_detail },
  { name: "废弃", path: util_api.customer_salary_adjust_apply_delete },
];
const paySystemXCLCDRTXConfig = {
  routeName: ["人事", "薪酬系统", "薪酬流程", "单人调薪"],
  apiList: paySystemXCLCDRTX,
};

// 薪酬系统-薪酬流程-批量调薪
const paySystemXCLCPLTX = [
  { name: "列表", path: util_api.customer_salary_adjust_apply_search },
  {
    name: "查看附件",
    path: util_api.customer_salary_adjust_apply_down_batch_adjust,
  },
  { name: "下载模版", path: util_api.customer_salary_adjust_batch_template },
  {
    name: "导入",
    path: util_api.customer_salary_adjust_apply_batch_apply_save,
  },
];
const paySystemXCLCPLTXConfig = {
  routeName: ["人事", "薪酬系统", "薪酬流程", "批量调薪"],
  apiList: paySystemXCLCPLTX,
};

// 薪酬系统-薪酬流程-薪资发放
const paySystemXCLCXZFF = [
  { name: "列表", path: util_api.customer_salary_payment_apply_search },
  ...paySystemXZFFCYZSCommon,
];
const paySystemXCLCXZFFConfig = {
  routeName: ["人事", "薪酬系统", "薪酬流程", "薪资发放"],
  apiList: paySystemXCLCXZFF,
};
// SPU 配置
const spuConfigApi = [
  {
    name: "获取配置列表",
    path: util_api.enum_config_list,
  },
  {
    name: "添加配置",
    path: util_api.enum_config_add,
  },
  {
    name: "更新配置",
    path: util_api.enum_config_update,
  },
  {
    name: "修改配置状态",
    path: util_api.enum_config_change_status,
  },
];
// SPU 管理
const spuSystemApi = [
  {
    name: "查询SPU列表",
    path: util_api.cya_spu_query,
  },
  {
    name: "保存SPU",
    path: util_api.cya_spu_save,
  },
  {
    name: "保存SPU申请",
    path: util_api.cya_spu_save_application,
  },
  {
    name: "获取SPU详情",
    path: util_api.cya_spu_detail,
  },
  {
    name: "修改SPU状态",
    path: util_api.cya_spu_chage_status,
  },
  ...flowBasicApiList,
];
const spuConfigConfig = {
  routeName: ["SPU研发管理", "SPU研发配置"],
  apiList: spuConfigApi,
};

const spuSystemConfig = {
  routeName: ["SPU研发管理", "SPU列表"],
  apiList: spuSystemApi,
};

// 模块和接口对应关系，用于初始化数据
const apiConfig = [
  spuConfigConfig, // SPU 配置
  spuSystemConfig, // SPU管理
  paySystemXCCYConfig,
  paySystemCBSZConfig,
  paySystemJCJSConfig,
  paySystemJCBLConfig,
  paySystemJCXZFConfig,
  paySystemXZFFCYZSConfig,
  paySystemXCLCDRTXConfig,
  paySystemXCLCPLTXConfig,
  paySystemXCLCXZFFConfig,
  {
    routeName: ["常用", "找人"],
    apiList: [
      { name: "查询人员列表", path: "common/search_customer" },
      { name: "获取工位位置", path: "office_map/location" },
    ],
  },
  {
    routeName: ["常用", "同学会"],
    apiList: [
      { name: "查询团队列表", path: "team/parent_teams" },
      { name: "查询团队正式员工列表", path: "team/formal_customers" },
      {
        name: "查询员工徽章，未返回数据，用处未知",
        path: "customer/activity_badges",
      },
    ],
  },
  {
    routeName: ["常用", "wiki"],
    apiList: [
      { name: "查询wiki列表", path: "wiki/query" },
      { name: "修改wiki内容", path: "wiki/update" },
      { name: "获取wiki内容", path: "wiki/detail" },
      { name: "添加wiki标签", path: "wiki/add_tag" },
      { name: "删除wiki标签", path: "wiki/del_tag" },
      { name: "删除wiki", path: "wiki/del_file" },
    ],
  },
  {
    routeName: ["我的", "个人信息"],
    apiList: [
      { name: "获取个人主页平台列表", path: "home_page/get_all" },
      { name: "添加个人主页平台项", path: "home_page/add" },
      { name: "更新个人主页", path: "customer_home_page/update" },
      { name: "获取个人信息", path: "customer/detail" },
      { name: "更新qq号", path: "customer/update_qq_number" },
      { name: "更新昵称", path: "customer/update_nickname" },
      { name: "更新微信号", path: "customer/update_wechat_number" },
      { name: "更新头像", path: "customer_info/upload_avatar" },
      { name: "添加兴趣爱好", path: "customer_interest/add" },
      { name: "修改个人简介", path: "customer_info/update_intro" },
      { name: "查询工区信息列表", path: "office_map/list" },
      { name: "定位工位位置", path: "office_map/locate" },
      { name: "查询我是否有期权", path: "customer_option/has_option" },
      { name: "查询我的期权", path: "customer_option/my_option" },
      { name: "查询我的期权订单", path: "option_order/mine" },
      { name: "保存出售期权订单", path: "option_order/submit" },
      { name: "删除出售期权订单", path: "option_order/delete" },
      { name: "期权验证码", path: "customer_option/send_sms" },
    ],
  },
  {
    routeName: ["我的", "发票夹"],
    apiList: [
      { name: "查询发票列表", path: "invoice/query_non_invoice_list" },
      { name: "查询发票统计信息", path: "invoice/query_non_invoice_statistic" },
      { name: "修改备注", path: "expense/update_invoice_remark" },
    ],
  },
  {
    routeName: ["业务申请/处理", "合同用章申请"],
    apiList: [
      { name: "更新mis配置", path: "mis_config/update" },
      { name: "查询mis配置", path: "mis_config/detail" },
      { name: "查询合同相关信息", path: "expense_group/query_relate" },
      { name: "合同模板下载", path: "bfile/attachment_url" },
      { name: "查询人员信息，包括team", path: "customer/query_with_team" },
      { name: "查询供应商列表", path: "payee_company/query_account" },
      { name: "查询存货物", path: "stock/query" },
      ...contractApi,
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["业务申请/处理", "合同用章申请", "履约人员配置按钮"],
    apiList: [
      { name: "更新mis配置", path: "mis_config/update" },
      { name: "查询mis配置", path: "mis_config/detail" },
    ],
  },
  {
    routeName: ["业务申请/处理", "兼职外包(云账户)合同申请"],
    apiList: [
      { name: "上传附件", path: "bfile/upload_attachment" },
      { name: "查询正式员工", path: "customer/es_query_formal" },
      ...outSourceContractApi,
      ...flowBasicApiList,
    ],
  },
  {
    routeName: [
      "业务申请/处理",
      "兼职外包(云账户)合同申请",
      "是否兼职（按钮权限）",
    ],
    apiList: [],
  },
  {
    routeName: ["业务申请/处理", "付款申请"],
    apiList: [...expenseGroupPageApi, ...flowBasicApiList],
  },
  {
    routeName: ["业务申请/处理", "预支申请"],
    apiList: [...expenseGroupPageApi, ...flowBasicApiList],
  },
  {
    routeName: ["业务申请/处理", "报销申请"],
    apiList: [...expenseGroupPageApi, ...flowBasicApiList],
  },
  {
    routeName: ["业务申请/处理", "报销申请", "报销申请-添加"],
    apiList: [],
  },
  {
    routeName: ["业务申请/处理", "账单提交"],
    apiList: [...expenseGroupPageApi, ...flowBasicApiList],
  },
  {
    routeName: ["业务申请/处理", "费用充值"],
    apiList: [...expenseGroupPageApi, ...flowBasicApiList],
  },
  {
    routeName: ["业务申请/处理", "发票提交"],
    apiList: [...expenseGroupPageApi, ...flowBasicApiList],
  },
  {
    routeName: ["业务申请/处理", "费用充值冲销"],
    apiList: [...expenseGroupPageApi, ...flowBasicApiList],
  },
  {
    routeName: ["业务申请/处理", "费用计提"],
    apiList: [...expenseGroupPageApi, ...flowBasicApiList],
  },
  {
    routeName: ["业务申请/处理", "费用计提修正"],
    apiList: [...expenseGroupPageApi, ...flowBasicApiList],
  },
  {
    routeName: ["业务申请/处理", "人员招聘申请"],
    apiList: [
      { name: "查询人员招聘申请列表", path: "recruit_need/query_mine" },
      { name: "查询人员招聘类型", path: "recruit_type/get_all" },
      { name: "保存招聘申请", path: "recruit_need/update" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["业务申请/处理", "预算申请"],
    apiList: [
      { name: "查询预算申请列表", path: "budget_order/mine_list" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["业务申请/处理", "预算申请", "预算申请详情"],
    apiList: [{ name: "查询预算申请详情", path: "budget_order/detail" }],
  },
  {
    routeName: ["业务申请/处理", "预算申请", "新增预算按钮"],
    apiList: [
      { name: "创建预算申请", path: "budget_order/create" },
      { name: "创建子单", path: "budget_order/create_sub_order" },
      { name: "查询子单详情", path: "budget_order/sub_order_detail" },
      { name: "删除子单详情", path: "budget_order/delete_sub_order" },
    ],
  },
  {
    routeName: ["业务申请/处理", "预算申请", "设置/取消预算为重要"],
    apiList: [{ name: "设置重要性", path: "budget_order/change_important" }],
  },
  {
    routeName: ["业务申请/处理", "预算申请", "查看获批预算"],
    apiList: [{ name: "查询已获批预算", path: "budget_amount/quarter_amount" }],
  },
  {
    routeName: ["业务申请/处理", "开店申请"],
    apiList: [
      { name: "查询开店申请列表", path: "opening_shop_order/query_mine" },
      { name: "保存开店申请列表", path: "opening_shop_order/save" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["业务申请/处理", "开店申请", "法务相关"],
    apiList: [],
  },
  {
    routeName: ["业务申请/处理", "待处理合同"],
    apiList: [...contractApi, ...flowBasicApiList],
  },
  {
    routeName: ["存货管理"],
    apiList: [],
  },
  {
    routeName: ["存货管理", "存货编码申请"],
    apiList: [],
  },
  {
    routeName: ["存货管理", "存货指标"],
    apiList: [],
  },
  {
    routeName: ["存货管理", "存货预警设置"],
    apiList: [],
  },
  {
    routeName: ["存货管理", "最佳采购量计算器"],
    apiList: [],
  },
  {
    routeName: ["存货管理", "商品上架申请"],
    apiList: [],
  },
  {
    routeName: ["差旅预订"],
    apiList: [],
  },
  {
    routeName: ["差旅预订", "机票/火车票/酒店预订"],
    apiList: [
      { name: "查询差旅预定申请列表", path: "travel_order/query_mine" },
      { name: "保存出行订单", path: "travel_order/update" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["固定资产"],
    apiList: [],
  },
  {
    routeName: ["固定资产", "固定资产申请"],
    apiList: [
      { name: "获取固定资产申请列表", path: "asset_order/query_mine" },
      { name: "提交固定资产申请", path: "asset_order/add" },
      { name: "删除固定资产申请", path: "asset_order/delete" },
      { name: "固定资产表单配置", path: "asset/base_data" },
      { name: "更新固定资产申请", path: "asset_order/update" },
      { name: "废弃固定资产申请", path: "asset_order/update" },
    ],
  },
  {
    routeName: ["固定资产", "我的固定资产"],
    apiList: [
      { name: "查询我的固定资产列表", path: "asset/query_mine" },
      { name: "id查询固定资产", path: "asset/query_by_id" },
      { name: "查询用户信息", path: "customer/query_with_team_company" },
      { name: "提交转移/归还申请", path: "asset_customer_operate/add" },
      { name: "修改设备备注", path: "asset_customer_remark/update" },
      { name: "删除转移申请", path: "asset_customer_operate/delete" },
    ],
  },
  {
    routeName: ["固定资产", "组内固定资产"],
    apiList: [
      { name: "查询组内固定资产", path: "asset/query_mine_team" },
      { name: "导出组内固定资产信息", path: "asset/export_mine_team" },
    ],
  },
  {
    routeName: ["实习生推荐奖", "发放申请"],
    apiList: [
      { name: "查询实习生推荐奖列表", path: "rec_award_topic/query" },
      { name: "查询实习生推荐奖详情", path: "rec_award_topic/detail" },
      { name: "修改实习生推荐奖申请", path: "rec_award_topic/update" },
      { name: "废弃实习生推荐奖申请", path: "rec_award_topic/delete" },
      { name: "删除记录", path: "rec_award_topic/delete_record" },
      { name: "更新支付宝", path: "rec_award_record/update_alipay" },
      { name: "发放", path: "rec_award_record/repay" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["财务报表V2"],
    apiList: [],
  },
  {
    routeName: ["财务报表V2", "仪表盘-实时"],
    apiList: [],
  },
  {
    routeName: ["财务报表V2", "仪表盘-月报"],
    apiList: [],
  },
  {
    routeName: ["财务报表设置V2"],
    apiList: [],
  },
  {
    routeName: ["财务报表设置V2", "财务数据录入"],
    apiList: [
      { name: "查询自定义类型列表", path: "fin_expense_type/manual_types" },
      { name: "查询财务分组", path: "fin_team/get_all" },
      { name: "查询财务数据", path: "fin_team_expense/manual_data" },
      { name: "更新财务数据", path: "fin_team_expense/update_manual_data" },
    ],
  },
  {
    routeName: ["财务报表设置V2", "费用类别设置"],
    apiList: [
      { name: "查询财务类型", path: "fin_expense_type/get_all" },
      { name: "更新财务类别", path: "fin_expense_type/update" },
    ],
  },
  {
    routeName: ["财务报表设置V2", "团队关联设置"],
    apiList: [
      { name: "查询财务团队分组", path: "fin_team/team_and_group" },
      { name: "更新分组", path: "fin_team/update_team" },
    ],
  },
  {
    routeName: ["财务报表设置V2", "团队阶段设置"],
    apiList: [
      { name: "查询团队阶段列表", path: "fin_team_period/list" },
      { name: "查询团队阶段月数据", path: "fin_team_period/month_data" },
      { name: "更新团队阶段配置", path: "fin_team_period/update" },
    ],
  },
  {
    routeName: ["财务报表设置V2", "课程数据录入"],
    apiList: [
      { name: "课程数据列表", path: "course_data_type/list" },
      { name: "课程列表", path: "course/list" },
      { name: "查询课程数据", path: "course_data/manual_data" },
      { name: "更新课程数据", path: "course_data/update_manual_course_data" },
    ],
  },
  {
    routeName: ["财务报表设置V2", "课程设置"],
    apiList: [
      { name: "查询课程列表", path: "course/list" },
      { name: "查询课程数据类型列表", path: "course_data_type/list" },
      { name: "更新课程", path: "course/update" },
      { name: "更新课程数据类型", path: "course_data_type/update" },
    ],
  },
  {
    routeName: ["仪表盘"],
    apiList: [],
  },
  {
    routeName: ["仪表盘", "现金收入"],
    apiList: [],
  },
  {
    routeName: ["仪表盘", "powerBi测试"],
    apiList: [],
  },
  {
    routeName: ["仪表盘", "财务数据仪表盘（管理层版）", "tableau测试"],
    apiList: [],
  },
  {
    routeName: ["仪表盘", "现金收入_1"],
    apiList: [],
  },
  {
    routeName: ["仪表盘", "资金仪表盘（管理层）"],
    apiList: [],
  },
  {
    routeName: ["仪表盘", "资金监控系统（财务）"],
    apiList: [],
  },
  {
    routeName: ["仪表盘", "资金监控系统（财务）", "账户流水"],
    apiList: [],
  },
  {
    routeName: ["仪表盘", "资金监控系统（财务）", "差异单据&差异流水"],
    apiList: [],
  },
  {
    routeName: ["仪表盘设置", "团队项目配置"],
    apiList: [],
  },
  {
    routeName: ["人事"],
    apiList: [],
  },
  {
    routeName: ["人事", "工资管理", "工资条"],
    apiList: [{ name: "获取工资条条目", path: "wage/items" }],
  },
  {
    routeName: ["人事", "工资管理", "工资留言"],
    apiList: [],
  },
  {
    routeName: ["人事", "工资管理", "社保公积金"],
    apiList: [],
  },
  {
    routeName: ["人事", "员工"],
    apiList: [
      { name: "查询员工列表", path: "customer/query_customer" },
      { name: "更新员工信息", path: "customer/update_customer" },
      { name: "更新员工生涯信息", path: "customer/update_career" },
      { name: "查询员工详情信息", path: "customer/detail" },
    ],
  },
  {
    routeName: ["人事", "员工信息收集"],
    apiList: [
      { name: "查询收集信息列表", path: "pre_customer/query" },
      { name: "修改信息", path: "pre_customer/update" },
      { name: "删除信息", path: "pre_customer/delete" },
      { name: "员工入职", path: "pre_customer/turn_into_customer" },
    ],
  },
  {
    routeName: ["人事", "招聘需求"],
    apiList: [
      { name: "查询审批流程", path: "flow/get_by_link_model" },
      { name: "获取招聘类型配置", path: "recruit_type/get_all" },
      { name: "查询招聘需求", path: "recruit_need/query" },
      { name: "查询我的招聘需求", path: "recruit_need/query_mine" },
      { name: "更新招聘需求", path: "recruit_need/update" },
      { name: "查询招聘需求详情", path: "recruit_need/detail" },
      { name: "删除招聘需求", path: "recruit_need/delete" },
    ],
  },
  {
    routeName: ["人事", "员工合同预警"],
    apiList: [{ name: "查询预警列表", path: "career/alert" }],
  },
  {
    routeName: ["人事", "员工资料预警"],
    apiList: [
      { name: "查询资料预警列表", path: "customer_info/material_alert" },
    ],
  },
  {
    routeName: ["人事", "数据导出"],
    apiList: [
      { name: "查询导出列表", path: "export/list" },
      { name: "导出文件", path: "export/file_url" },
    ],
  },
  {
    routeName: ["人事", "同学会编辑"],
    apiList: [
      { name: "查询团队列表", path: "team/parent_teams" },
      { name: "查询同学", path: "schoolmate/query" },
      { name: "修改标签", path: "hr/culture/edit_customer_intro" },
      { name: "修改头像", path: "hr/culture/upload_customer_candid_photo" },
    ],
  },
  {
    routeName: ["人事", "批量处理"],
    apiList: [
      { name: "查询目标负责人", path: "customer/query_director" },
      {
        name: "查询用来批量操作的用户",
        path: "customer/query_for_batch_operation",
      },
      {
        name: "批量设置员工目标负责人",
        path: "batch_operate/batch_set_director",
      },
    ],
  },
  {
    routeName: ["人事", "公司"],
    apiList: [
      { name: "查询公司列表", path: "company/get_companies" },
      { name: "更新公司", path: "company/update" },
    ],
  },
  {
    routeName: ["人事", "团队"],
    apiList: [
      { name: "获取团队关系树", path: "team/tree_info" },
      { name: "更新团队信息", path: "team/update" },
      { name: "删除团队", path: "team/update" },
      { name: "查询团队成员", path: "customer/team_customer" },
      { name: "批量设置人员团队", path: "customer/batch_set_team" },
    ],
  },
  {
    routeName: ["人事", "岗位"],
    apiList: [
      { name: "查询岗位列表", path: "job/get_jobs" },
      { name: "修改岗位信息", path: "job/update" },
      { name: "删除岗位", path: "job/delete" },
    ],
  },
  {
    routeName: ["人事", "薪酬系统", "薪酬管理", "产研-正式"],
    apiList: [],
  },
  {
    routeName: ["人事", "薪酬系统", "薪酬管理", "消息提醒"],
    apiList: [],
  },
  {
    routeName: ["人事", "薪酬系统", "规则设置", "缴存基数"],
    apiList: [],
  },
  {
    routeName: ["人事", "薪酬系统", "规则设置", "缴存比例"],
    apiList: [],
  },
  {
    routeName: ["人事", "薪酬系统", "规则设置", "餐补设置"],
    apiList: [],
  },
  {
    routeName: ["人事", "薪酬系统", "薪资发放", "产研-正式"],
    apiList: [],
  },
  {
    routeName: ["人事", "薪酬系统", "薪资发放", "销服-正式"],
    apiList: [],
  },
  {
    routeName: ["人事", "薪酬系统", "薪酬流程", "单人调薪"],
    apiList: [],
  },
  {
    routeName: ["人事", "薪酬系统", "薪酬流程", "批量调薪"],
    apiList: [],
  },
  {
    routeName: ["人事", "薪酬系统", "薪酬流程", "薪资发放"],
    apiList: [],
  },
  {
    routeName: ["人事", "薪酬系统", "薪酬流程", "状态-待提交（发起者可见）"],
    apiList: [],
  },
  {
    routeName: ["行政"],
    apiList: [],
  },
  {
    routeName: ["行政", "固定资产管理"],
    apiList: [
      { name: "获取固定资产配置信息", path: "asset/base_data" },
      { name: "查询资产信息", path: "asset/query" },
      { name: "保存设备信息", path: "asset/update" },
      { name: "通过ID查询设备", path: "asset/query_by_id" },
      { name: "查询用户设备", path: "asset/query_customer_assets" },
      { name: "添加入库记录", path: "asset_in_out_record/add" },
    ],
  },
  {
    routeName: ["行政", "固定资产管理", "固定资产盘点"],
    apiList: [],
  },
  {
    routeName: ["行政", "固定资产出入库明细"],
    apiList: [{ name: "查询出入库明细", path: "asset_in_out_record/query" }],
  },
  {
    routeName: ["行政", "固定资产流程汇总"],
    apiList: [
      { name: "查询固定资产流程", path: "asset_customer_operate/query" },
      { name: "完善信息", path: "asset_order/complement" },
      { name: "打印领用表", path: "asset/detail_for_print" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["行政", "机票火车票预订汇总"],
    apiList: [
      { name: "查询火车票预订列表", path: "travel_order/query" },
      { name: "编辑预订信息", path: "travel_order/update_item_info" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["行政", "设置"],
    apiList: [
      { name: "查询资产名称", path: "asset_name/query" },
      { name: "查询资产申请名称", path: "asset_order_name/query" },
      { name: "查询设备类型", path: "asset_device_type/query" },
      { name: "查询设备品牌", path: "asset_brand/query" },
      { name: "查询资产位置", path: "asset_location/query" },
      { name: "查询资产仓库", path: "asset_stock/query" },
      { name: "查询资产用途", path: "asset_purpose/query" },
      { name: "更新设备名称", path: "asset_name/update" },
      { name: "更新资产申请名称", path: "asset_order_name/update" },
      { name: "更新设备类型", path: "asset_device_type/update" },
      { name: "更新设备品牌", path: "asset_brand/update" },
      { name: "更新资产位置", path: "asset_location/update" },
      { name: "更新仓库", path: "asset_stock/update" },
      { name: "更新设备用途", path: "asset_purpose/update" },
    ],
  },
  {
    routeName: ["行政", "固定资产规则配置"],
    apiList: [
      { name: "查询需折旧单价", path: "asset_rule_depreciate_price/query" },
      {
        name: "查询月结供应商",
        path: "asset_rule_monthly_payee_company/query",
      },
      {
        name: "查询非折旧设备类型",
        path: "asset_rule_no_depreciate_device_type/query",
      },
      { name: "查询不抵扣公司", path: "asset_rule_no_deduct_company/query" },
      { name: "更新需折旧单价", path: "asset_rule_depreciate_price/update" },
      {
        name: "更新月结供应商",
        path: "asset_rule_monthly_payee_company/update",
      },
      {
        name: "更新非折旧设备类型",
        path: "asset_rule_no_depreciate_device_type/update",
      },
    ],
  },
  {
    routeName: ["行政", "手机管理"],
    apiList: [
      { name: "查询团队列表", path: "team/leader_list" },
      { name: "查询手机列表", path: "asset_phone/mobile_info_list" },
      { name: "更新手机信息", path: "asset_phone/update_mobile_account_info" },
    ],
  },
  {
    routeName: ["行政", "资产盘点"],
    apiList: [
      { name: "查询资产盘点信息", path: "asset_inventory_topic/list" },
      { name: "查询资产库存列表", path: "asset_inventory/list" },
      { name: "获取资产库存详情", path: "asset_inventory/detail" },
      { name: "删除资产盘点", path: "asset_inventory/delete" },
    ],
  },
  {
    routeName: ["行政", "资产盘点", "固定资产批次列表"],
    apiList: [],
  },
  {
    routeName: ["资产管理"],
    apiList: [],
  },
  {
    routeName: ["资产管理", "手机管理"],
    apiList: [
      {
        name: "按条件查询手机设备",
        path: "asset_phone/find_phones_with_condition",
      },
      {
        name: "通过资产号获取设备信息",
        path: "asset_phone/find_details_by_asset_number",
      },
      { name: "更新手机信息", path: "asset_phone/update" },
      { name: "根据id删除手机", path: "asset_phone/delete_phones_by_id" },
      {
        name: "查询手机号信息",
        path: "asset_phone_number/find_phone_numbers_with_condition",
      },
      { name: "更新手机号", path: "asset_phone_number/update" },
      {
        name: "查询账号列表",
        path: "asset_device_account/find_device_account_with_condition",
      },
      {
        name: "查询绑定列表",
        path: "asset_relative_details/find_relative_details_with_condition",
      },
      {
        name: "根据id解除绑定关系",
        path: "asset_relative_details/delete_relative_details_by_id",
      },
      {
        name: "根据设备号获取详情",
        path: "asset_phone/find_details_by_asset_number",
      },
      {
        name: "获取手机号详情",
        path: "asset_phone_number/find_details_by_phone_number",
      },
      {
        name: "获取账号详情",
        path: "asset_device_account/find_details_by_device_account",
      },
      {
        name: "获取绑定关系详情",
        path: "asset_relative_details/find_details_by_relative",
      },
      {
        name: "根据id删除账号",
        path: "asset_device_account/delete_device_account_by_id",
      },
      {
        name: "根据id删除手机号",
        path: "asset_phone_number/delete_phone_number_by_id",
      },
      {
        name: "删除课程",
        path: "asset_phone_number/delete_phone_number_course",
      },
      {
        name: "解绑设备",
        path: "asset_relative_details/dis_connect_device_account",
      },
      {
        name: "解绑手机号",
        path: "asset_relative_details/dis_connect_phone_number",
      },
      { name: "添加/更新资产绑定关系", path: "asset_relative_details/update" },
      { name: "更新设备账号信息", path: "asset_device_account/update" },
    ],
  },
  {
    routeName: ["财务"],
    apiList: [],
  },
  {
    routeName: ["财务", "合同管理"],
    apiList: [
      { name: "查询相关信息", path: "expense_group/query_relate" },
      ...contractApi,
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["财务", "合同管理", "合同管理&合同盖章申请[财务核算审核相关]"],
    apiList: [],
  },
  {
    routeName: ["财务", "盖章归档登记"],
    apiList: [
      { name: "查询盖章归档", path: "file_stamp/query" },
      { name: "更新归档状态", path: "file_stamp/update_status" },
      { name: "添加附件/备注", path: "file_stamp/add_accessory" },
      { name: "导出列表", path: "file_stamp/download_list" },
    ],
  },
  {
    routeName: ["财务", "待付款采购类合同"],
    apiList: [
      { name: "查询到货情况", path: "stock_in_record/arrived" },
      { name: "查询待付款合同", path: "contract/query_need_pay" },
      { name: "归档", path: "contract/update_files" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["财务", "兼职外包(云账户)合同管理"],
    apiList: [
      { name: "查询外包合同", path: "outsource_contract/query" },
      { name: "查询外包合同详情", path: "outsource_contract/detail" },
      {
        name: "查询外包合同相关处理列表",
        path: "outsource_contract/related_placing_records",
      },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["财务", "付款申请"],
    apiList: [
      { name: "查询付款申请", path: "expense_group/es_query" },
      { name: "批量生成账单", path: "expense_group/transform_batch" },
      { name: "冲销单据", path: "expense_group/write_off" },
      { name: "删除付款单", path: "expense_group/delete" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["财务", "付款申请", "编辑按钮"],
    apiList: [{ name: "更新申请", path: "expense_group/update_desc" }],
  },
  {
    routeName: ["财务", "费用预支"],
    apiList: [
      { name: "查询付款申请", path: "expense_group/es_query" },
      { name: "批量生成账单", path: "expense_group/transform_batch" },
      { name: "冲销单据", path: "expense_group/write_off" },
      { name: "删除付款单", path: "expense_group/delete" },
      { name: "查询支出", path: "expense_group/query_expense" },
      { name: "银行退款", path: "expense_group/refund" },
      { name: "查询支出详情", path: "expense_group/detail" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["财务", "费用报销"],
    apiList: [
      { name: "查询付款申请", path: "expense_group/es_query" },
      { name: "批量生成账单", path: "expense_group/transform_batch" },
      { name: "冲销单据", path: "expense_group/write_off" },
      { name: "删除付款单", path: "expense_group/delete" },
      { name: "查询支出", path: "expense_group/query_expense" },
      { name: "银行退款", path: "expense_group/refund" },
      { name: "查询支出详情", path: "expense_group/detail" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["财务", "费用充值"],
    apiList: [
      { name: "查询付款申请", path: "expense_group/es_query" },
      { name: "批量生成账单", path: "expense_group/transform_batch" },
      { name: "冲销单据", path: "expense_group/write_off" },
      { name: "删除付款单", path: "expense_group/delete" },
      {
        name: "查询支出记录",
        path: "expense_payment_record/find_by_expense_group",
      },
      { name: "查询支出", path: "expense_group/query_expense" },
      { name: "银行退款", path: "expense_group/refund" },
      { name: "查询支出详情", path: "expense_group/detail" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["财务", "费用充值冲销"],
    apiList: [
      { name: "查询付款申请", path: "expense_group/es_query" },
      { name: "批量生成账单", path: "expense_group/transform_batch" },
      { name: "冲销单据", path: "expense_group/write_off" },
      { name: "删除付款单", path: "expense_group/delete" },
      {
        name: "查询支出记录",
        path: "expense_payment_record/find_by_expense_group",
      },
      { name: "查询支出", path: "expense_group/query_expense" },
      { name: "银行退款", path: "expense_group/refund" },
      { name: "查询支出详情", path: "expense_group/detail" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["财务", "充值余额查询"],
    apiList: [
      { name: "获取支出类型", path: "expense_type/get_all" },
      {
        name: "查询充值余额",
        path: "recharge_write_off/query_payee_companies",
      },
    ],
  },
  {
    routeName: ["财务", "费用计提"],
    apiList: [
      { name: "查询付款申请", path: "expense_group/es_query" },
      { name: "批量生成账单", path: "expense_group/transform_batch" },
      { name: "冲销单据", path: "expense_group/write_off" },
      { name: "删除付款单", path: "expense_group/delete" },
      {
        name: "查询支出记录",
        path: "expense_payment_record/find_by_expense_group",
      },
      { name: "查询支出", path: "expense_group/query_expense" },
      { name: "银行退款", path: "expense_group/refund" },
      { name: "查询支出详情", path: "expense_group/detail" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["财务", "费用计提修正"],
    apiList: [
      { name: "查询付款申请", path: "expense_group/es_query" },
      { name: "批量生成账单", path: "expense_group/transform_batch" },
      { name: "冲销单据", path: "expense_group/write_off" },
      { name: "删除付款单", path: "expense_group/delete" },
      {
        name: "查询支出记录",
        path: "expense_payment_record/find_by_expense_group",
      },
      { name: "查询支出", path: "expense_group/query_expense" },
      { name: "银行退款", path: "expense_group/refund" },
      { name: "查询支出详情", path: "expense_group/detail" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["财务", "发票提交"],
    apiList: [
      { name: "查询付款申请", path: "expense_group/es_query" },
      { name: "批量生成账单", path: "expense_group/transform_batch" },
      { name: "冲销单据", path: "expense_group/write_off" },
      { name: "删除付款单", path: "expense_group/delete" },
      {
        name: "查询支出记录",
        path: "expense_payment_record/find_by_expense_group",
      },
      { name: "查询支出", path: "expense_group/query_expense" },
      { name: "银行退款", path: "expense_group/refund" },
      { name: "查询支出详情", path: "expense_group/detail" },
      { name: "生成工资应付单", path: "wage/gen_bill" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["财务", "账单提交"],
    apiList: [
      { name: "查询付款申请", path: "expense_group/es_query" },
      { name: "批量生成账单", path: "expense_group/transform_batch" },
      { name: "冲销单据", path: "expense_group/write_off" },
      { name: "删除付款单", path: "expense_group/delete" },
      {
        name: "查询支出记录",
        path: "expense_payment_record/find_by_expense_group",
      },
      { name: "查询支出", path: "expense_group/query_expense" },
      { name: "银行退款", path: "expense_group/refund" },
      { name: "查询支出详情", path: "expense_group/detail" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["财务", "收款单"],
    apiList: [
      { name: "查询收款单", path: "income_group/es_query" },
      { name: "查询收款单详情", path: "income_group/detail" },
      { name: "更新收款单", path: "income_group/update" },
      { name: "删除收款单", path: "income_group/delete" },
    ],
  },
  {
    routeName: ["财务", "投放记录（财务）"],
    apiList: [
      { name: "获取配置", path: "enum_config/list" },
      { name: "查询投放记录", path: "placing_ads_record/query" },
      { name: "投放详情", path: "placing_ads_record/detail" },
      { name: "保存投放记录", path: "placing_ads_record/save" },
      { name: "保存加成服务", path: "placing_ads_vas_record/save" },
    ],
  },
  {
    routeName: ["财务", "待付款清单导出"],
    apiList: [
      { name: "查询支付银行", path: "finance/get_expense_payment_banks" },
      { name: "查询导出记录", path: "expense_group_export_log/recent" },
      { name: "通过uid查询付款充值预支", path: "expense_group/query_by_uid" },
      { name: "查询导出记录详情", path: "expense_group_export_log/detail" },
      { name: "重新载入记录", path: "expense_group_export_log/reload" },
      { name: "撤销导出", path: "expense_group_export_check/delete" },
      { name: "查询确认列表", path: "expense_group_export_check/list" },
      { name: "批量完结", path: "expense_group_export_check/batch_finish" },
    ],
  },
  {
    routeName: ["财务", "付款信息审核"],
    apiList: [
      { name: "查询确认列表", path: "expense_group_export_check/list" },
    ],
  },
  {
    routeName: ["财务", "数据导出中心"],
    apiList: [{ name: "导出列表", path: "export/list" }],
  },
  {
    routeName: ["财务", "数据导出中心", "工资汇总导出按钮"],
    apiList: [{ name: "请求导出工资汇总", path: "export/wage_record" }],
  },
  {
    routeName: ["财务", "实习生工资"],
    apiList: [
      { name: "获取实习生工资发放记录", path: "informal_wage_topic/list" },
      { name: "查询实习生工资发放详情", path: "informal_wage_topic/detail" },
      { name: "更新发放记录备注", path: "informal_wage_record/update_desc" },
      { name: "更新发放记录", path: "informal_wage_record/update" },
      { name: "废弃发放记录", path: "informal_wage_record/abandon" },
      {
        name: "查询负责人申请流程",
        path: "informal_wage_topic/director_topics",
      },
      { name: "发送提醒", path: "director_informal_wage_topic/send_notice" },
      {
        name: "关闭流程通道确认",
        path: "informal_wage_topic/update_status_confirm",
      },
      { name: "更新流程状态", path: "informal_wage_topic/update_status" },
      {
        name: "导入实收个税数据",
        path: "director_informal_wage_topic/import_records",
      },
    ],
  },
  {
    routeName: ["财务", "实习生工资", "实习生津贴详情"],
    apiList: [],
  },
  {
    routeName: ["财务", "云账户兼职员工工资"],
    apiList: [
      { name: "查询外包工资发放", path: "outsource_wage_topic/query" },
      { name: "保存外包工资发放记录", path: "outsource_wage_topic/update" },
      { name: "查询外包工资发放详情", path: "outsource_wage_topic/detail" },
      {
        name: "更新外包工资发放状态",
        path: "outsource_wage_topic/update_status",
      },
      {
        name: "查询外包工资发放流程",
        path: "outsource_wage_topic/director_topics",
      },
      { name: "批量发放外包工资", path: "outsource_wage_topic/batch_pay" },
      { name: "恢复外包发放记录", path: "outsource_wage_record/recover" },
      { name: "重试发放工资", path: "outsource_wage_record/repay" },
      {
        name: "导出外包发放记录",
        path: "outsource_wage_topic/export_wage_data",
      },
      { name: "导出付款数据", path: "outsource_wage_topic/export" },
    ],
  },
  {
    routeName: ["财务", "奖金管理"],
    apiList: [
      { name: "导入数据", path: "bonus_reward/import" },
      { name: "查询奖金数据", path: "bonus_reward/get" },
    ],
  },
  {
    routeName: ["财务", "文件管理"],
    apiList: [
      { name: "查询文件", path: "bfile/query" },
      { name: "删除文件", path: "bfile/delete" },
      { name: "更新文件", path: "bfile/update" },
      { name: "上传文件到OSS", path: "bfile/upload_to_oss" },
      { name: "更新OSS文件", path: "bfile/upload_attachment" },
      { name: "下载文件", path: "bfile/oss_url" },
      { name: "分享文件", path: "bfile/share_customers" },
      { name: "分享文件给某用户", path: "bfile/add_share_customer" },
      { name: "取消分享", path: "bfile/delete_share_customer" },
      { name: "删除模板文件", path: "bfile/delete_model_file" },
    ],
  },
  {
    routeName: ["财务", "员工账户管理"],
    apiList: [
      { name: "查询员工账户", path: "customer_account/query" },
      { name: "更新员工账户", path: "customer_account/update" },
    ],
  },
  {
    routeName: ["财务", "期权管理"],
    apiList: [
      { name: "导入期权", path: "customer_option/import" },
      { name: "查询期权", path: "customer_option/options" },
      {
        name: "查询用户团队和公司信息",
        path: "customer/query_with_team_company",
      },
      { name: "更新期权", path: "customer_option/update" },
      { name: "删除期权", path: "customer_option/delete" },
      { name: "查询期权订单", path: "option_order/orders" },
      { name: "导出期权订单", path: "option_order/export" },
      { name: "我的期权订单", path: "option_order/mine" },
      { name: "获取订单用户", path: "option_order/customers" },
    ],
  },
  {
    routeName: ["财务", "人民币汇率中间价"],
    apiList: [
      { name: "获取rmb汇率中间价", path: "finance/rmb_central_parities" },
      {
        name: "导出人民币汇率中间价",
        path: "finance/export_rmb_central_parities",
      },
    ],
  },
  {
    routeName: ["财务", "发送财务短信"],
    apiList: [
      { name: "获取发送日志", path: "sms_log/query" },
      { name: "通过联系方式查询用户", path: "customer/query_with_contact" },
      { name: "批量发短信", path: "sms_log/batch_send" },
      { name: "重新发送", path: "sms_log/retry" },
    ],
  },
  {
    routeName: ["财务", "预算申请"],
    apiList: [
      { name: "获取预算申请列表", path: "budget_order/list" },
      { name: "删除预算母单", path: "budget_order/delete" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["财务", "预算申请", "预算申请详情"],
    apiList: [{ name: "查询预算详情", path: "budget_order/full_detail" }],
  },
  {
    routeName: ["财务", "预算申请", "新增预算申请按钮"],
    apiList: [{ name: "新增预算母单", path: "budget_order/create" }],
  },
  {
    routeName: ["财务", "预算申请", "设置/取消预算为重要"],
    apiList: [
      { name: "设置单据重要或取消", path: "budget_order/change_important" },
    ],
  },
  {
    routeName: ["财务", "预算申请", "查看获批预算"],
    apiList: [{ name: "查询已获批预算", path: "budget_amount/quarter_amount" }],
  },
  {
    routeName: ["财务", "消耗计划"],
    apiList: [
      { name: "查询消耗计划单", path: "cost_plan_bill/es_query" },
      { name: "生成消耗计划单", path: "cost_plan_bill/generate" },
      { name: "更新消耗计划单", path: "cost_plan_bill/update" },
      { name: "改变消耗计划单状态", path: "cost_plan_bill/change_status" },
      { name: "更新消耗计划", path: "cost_plan/update" },
    ],
  },
  {
    routeName: ["财务", "消耗计划", "消耗计划详情"],
    apiList: [{ name: "查询消耗计划单详情", path: "cost_plan_bill/detail" }],
  },
  {
    routeName: ["财务", "开店审核"],
    apiList: [
      { name: "查询开店审核申请", path: "opening_shop_order/query" },
      { name: "查询开店审核申请详情", path: "opening_shop_order/detail" },
      { name: "申请开店", path: "opening_shop_order/save" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["财务", "财务费用预估"],
    apiList: [
      { name: "查询月薪资列表", path: "customer_month_salary_total/list" },
      {
        name: "查询当前月份薪资总额",
        path: "customer_month_salary_total/current_month_pay",
      },
      {
        name: "内推/猎头费用",
        path: "customer_month_salary_total/cost_statistics",
      },
      { name: "下载内推数据", path: "hr/cost/cost_statistics_download_of_mis" },
      {
        name: "查询费用趋势列表",
        path: "customer_month_salary_total/cost_trend",
      },
    ],
  },
  {
    routeName: ["财务", "薪酬管理"],
    apiList: [
      {
        name: "获取薪资发放-薪资概要",
        path: "customer_month_salary_total/list",
      },
      { name: "获取薪资列表", path: "customer_basic_salary/info_page" },
      { name: "获取个人薪酬相关", path: "customer_basic_salary/info_detail" },
      { name: "获取修改薪酬历史", path: "customer_basic_salary/history_list" },
      {
        name: "获取缴存基数",
        path: "customer_insurance_payment_base/get_base",
      },
      {
        name: "获取缴存比例",
        path: "customer_insurance_payment_ratio/get_ratio",
      },
      { name: "获取缴存", path: "customer_meal_subsidy/list" },
      { name: "单独修改薪酬", path: "customer_basic_salary/update_salary" },
      {
        name: "批量修改薪酬",
        path: "customer_basic_salary/batch_update_salary",
      },
      { name: "修改基数", path: "customer_insurance_payment_base/update_base" },
      { name: "修改餐补", path: "customer_meal_subsidy/update" },
      {
        name: "修改缴存比例",
        path: "customer_insurance_payment_ratio/update_ratio",
      },
      { name: "查询薪资明细", path: "customer_month_salary_total/detail_list" },
      { name: "归档", path: "customer_month_salary_total/pigeonhole" },
      {
        name: "薪酬管理统计",
        path: "customer_month_salary_total/detail_count",
      },
      {
        name: "调整统计详情",
        path: "customer_month_salary_total/modify_detail",
      },
      {
        name: "获取推荐奖励明细",
        path: "customer_month_salary_total/recommend_award_detail",
      },
      {
        name: "hr_wxdata_financial_clock_in_data_of_customer",
        path: "hr/wxdata/financial/clock_in_data_of_customer",
      },
      {
        name: "导入数据",
        path: "customer_month_salary_total/import_salary_detail_info",
      },
      {
        name: "下载月薪酬详情",
        path: "customer_month_salary_total/download_detail",
      },
      {
        name: "查询当前月份薪资",
        path: "customer_month_salary_total/current_month_pay",
      },
    ],
  },
  {
    routeName: ["财务", "账期管理"],
    apiList: [
      { name: "公司账期查询", path: "company_account_period/query" },
      { name: "创建公司账期", path: "company_account_period/create" },
      { name: "更新公司账期标志", path: "company_account_period/update_flag" },
      { name: "查询广告投放记录", path: "placing_ads_record/select_search" },
      { name: "保存记录", path: "expense_group/save_placing_records" },
      { name: "查询相关记录", path: "expense_group/related_placing_records" },
      { name: "删除记录", path: "expense_group/delete_placing_records" },
      { name: "查询投放记录", path: "placing_ads_vas_record/select_search" },
    ],
  },
  {
    routeName: ["财务", "第三方店铺"],
    apiList: [
      { name: "审批端获取列表", path: "opening_shop_order/detail" },
      { name: "查询开店申请列表", path: "opening_shop_order/query_mine" },
      { name: "审批端查询", path: "opening_shop_order/query" },
      { name: "查询第三方店铺列表", path: "third_party_shop/query" },
      { name: "保存第三方店铺列表", path: "third_party_shop/save" },
      { name: "修改第三方店铺状态", path: "third_party_shop/modify_status" },
    ],
  },
  {
    routeName: ["财务", "账号管理"],
    apiList: [],
  },
  {
    routeName: ["财务核算组", "审核人员配置"],
    apiList: [
      { name: "获取列表", path: "audit_customer_model/audit_models" },
      { name: "保存人员", path: "audit_customer_model/save" },
    ],
  },
  {
    routeName: ["财务核算组", "收款用途配置"],
    apiList: [{ name: "更新收款用途", path: "rec_pay_purpose/update" }],
  },
  {
    routeName: ["财务单据", "付款单"],
    apiList: [
      { name: "查询付款单列表", path: "fin_payment_bill/query" },
      { name: "查询合同", path: "contract/find" },
    ],
  },
  {
    routeName: ["财务单据", "应付单"],
    apiList: [
      { name: "查询付款单列表", path: "fin_payment_bill/query" },
      { name: "查询合同", path: "contract/find" },
    ],
  },
  {
    routeName: ["财务单据", "付款计提单"],
    apiList: [
      { name: "查询付款计提单", path: "fin_payment_accrual_bill/query" },
      { name: "查询合同", path: "contract/find" },
    ],
  },
  {
    routeName: ["财务单据", "应收单"],
    apiList: [
      { name: "查询应收单", path: "fin_receivable_bill/query" },
      { name: "应收单items", path: "fin_receivable_bill/items" },
      { name: "更新应收单", path: "fin_receivable_bill/update" },
      { name: "创建应收单", path: "fin_receivable_bill/create" },
      { name: "删除应收单", path: "fin_receivable_bill/delete" },
      { name: "应收单详情", path: "fin_receivable_bill/detail" },
    ],
  },
  {
    routeName: ["财务单据", "收款单"],
    apiList: [
      { name: "查询收款单", path: "fin_receipt_bill/query" },
      { name: "收款单信息", path: "fin_receipt_bill/items" },
      { name: "创建收款单", path: "fin_receipt_bill/create" },
      { name: "删除收款单", path: "fin_receipt_bill/delete" },
      { name: "收款单详情", path: "fin_receipt_bill/detail" },
      {
        name: "fin_receipt_bill_transform_to_accrual",
        path: "fin_receipt_bill/transform_to_accrual",
      },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["财务单据", "收款单", "编辑按钮"],
    apiList: [{ name: "更新收款单", path: "fin_receipt_bill/update" }],
  },
  {
    routeName: ["财务单据", "收款计提单"],
    apiList: [
      { name: "查询计提单", path: "fin_receipt_accrual_bill/query" },
      { name: "计提单信息", path: "fin_receipt_accrual_bill/items" },
      { name: "创建计提单", path: "fin_receipt_accrual_bill/create" },
      { name: "删除计提单", path: "fin_receipt_accrual_bill/delete" },
      { name: "计提单详情", path: "fin_receipt_accrual_bill/detail" },
    ],
  },
  {
    routeName: ["财务单据", "收款计提单", "编辑按钮"],
    apiList: [{ name: "更新计提单", path: "fin_receipt_accrual_bill/update" }],
  },
  {
    routeName: ["财务单据", "费用拆分"],
    apiList: [
      { name: "查询拆分单", path: "fin_fee_distribute_bill/query" },
      { name: "拆分单内容", path: "fin_fee_distribute_bill/items" },
    ],
  },
  {
    routeName: ["财务设置", "费用科目设置"],
    apiList: [
      { name: "获取费用科目设置", path: "expense_type/get_all" },
      { name: "获取财务科目设置", path: "fin_expense_type/get_all" },
      { name: "获取财务支出类型", path: "fin_expense_type/final_types" },
      {
        name: "获取名字排序的现金流类型",
        path: "cash_flow_type/name_sorted_types",
      },
      {
        name: "获取上个版本的现金流类型",
        path: "cash_flow_type/last_generation_types",
      },
      { name: "修改费用科目设置", path: "expense_type/update" },
    ],
  },
  {
    routeName: ["财务设置", "员工费用科目设置"],
    apiList: [
      { name: "查询员工费用科目设置", path: "customer_expense_type/query" },
      { name: "更新员工费用科目设置", path: "customer_expense_type/update" },
      {
        name: "查询费用信息数据",
        path: "customer_expense_type/customer_title_mappings",
      },
    ],
  },
  {
    routeName: ["财务设置", "现金流科目设置"],
    apiList: [
      { name: "查询现金流配置", path: "cash_flow_type/get_all" },
      { name: "修改现金流类型", path: "cash_flow_type/update" },
    ],
  },
  {
    routeName: ["财务设置", "银行账户设置"],
    apiList: [
      { name: "查询银行账户", path: "finance/query_expense_payment_banks" },
      { name: "修改银行账户", path: "finance/update_expense_payment_bank" },
    ],
  },
  {
    routeName: ["财务设置", "科目迭代"],
    apiList: [
      { name: "查询费用nature列表", path: "expense_nature/list" },
      { name: "修改费用nature项目", path: "expense_nature/save" },
      { name: "改变费用nature状态", path: "expense_nature/change_status" },
      { name: "查询职能科目列表", path: "customer_function/list" },
      { name: "修改职能科目项目", path: "customer_function/save" },
      { name: "改变职能科目状态", path: "customer_function/change_status" },
      { name: "查询产品科目列表", path: "item_type/list" },
      { name: "修改产品科目项目", path: "item_type/save" },
      { name: "改变产品科目状态", path: "item_type/change_status" },
      { name: "查询会计科目列表", path: "account_title/all" },
      { name: "修改会计科目项目", path: "account_title/save" },
      { name: "改变会计科目状态", path: "account_title/change_status" },
      { name: "查询分析科目列表", path: "analysis_title/all" },
      { name: "修改分析科目项目", path: "analysis_title/save" },
      { name: "改变分析科目状态", path: "analysis_title/change_status" },
      { name: "查询用途科目列表", path: "fund_usage/list" },
      { name: "修改用途科目项目", path: "fund_usage/save" },
      { name: "改变用途科目状态", path: "fund_usage/change_status" },
    ],
  },
  {
    routeName: ["财务设置", "科目映射表"],
    apiList: [
      { name: "查询科目映射表", path: "title_mapping/query" },
      { name: "修改科目映射表", path: "title_mapping/update" },
      { name: "修改科目映射表状态", path: "title_mapping/change_status" },
      { name: "导出表格", path: "title_mapping/export" },
    ],
  },
  {
    routeName: ["财务设置", "工资科目映射"],
    apiList: [
      { name: "查询工资科目映射", path: "wage_title_mapping/all" },
      { name: "修改工资科目映射", path: "wage_title_mapping/update" },
    ],
  },
  {
    routeName: ["财务设置", "合同类别设置"],
    apiList: [
      { name: "查询合同类别列表", path: "contract_type/list" },
      { name: "修改合同类别", path: "contract_type/save" },
      { name: "修改合同类别状态", path: "contract_type/change_status" },
    ],
  },
  {
    routeName: ["财务设置", "工资科目映射（新）"],
    apiList: [
      { name: "查询工资科目映射列表", path: "salary_mapping/list" },
      { name: "修改工资科目映射", path: "salary_mapping/save" },
      { name: "新增工资科目映射", path: "salary_mapping/add_title_mapping" },
      { name: "删除工资科目映射", path: "salary_mapping/remove_title_mapping" },
      {
        name: "查询云账户工资科目映射列表",
        path: "outsource_contract_title_mapping/query",
      },
      {
        name: "删除云账户科目映射",
        path: "outsource_contract_title_mapping/delete",
      },
      {
        name: "修改云账户科目映射",
        path: "outsource_contract_title_mapping/save",
      },
      { name: "查询树信息", path: "salary_job_sequence/tree_info" },
      { name: "保存树信息", path: "salary_job_sequence/save" },
      {
        name: "查询销服人员映射",
        path: "sales_customer_function_mapping/query",
      },
      {
        name: "修改销服映射状态",
        path: "sales_customer_function_mapping/change_status",
      },
      { name: "修改销服映射", path: "sales_customer_function_mapping/save" },
    ],
  },
  {
    routeName: ["财务设置", "账号管理共享设置"],
    apiList: [],
  },
  {
    routeName: ["流水相关", "银行流水"],
    apiList: [
      { name: "查询银行流水", path: "bank_statement/query_item" },
      { name: "查询单据", path: "expense_group/statement_match_query" },
      { name: "修改银行流水", path: "bank_statement/update_item" },
      { name: "查询列表", path: "expense_group/statement_match_query" },
      { name: "上传银行流水", path: "bank_statement/upload_file" },
      { name: "同步CBS流水", path: "bank_statement/sync_item" },
    ],
  },
  {
    routeName: ["流水相关", "自动单据配置"],
    apiList: [
      { name: "查询付款规则列表", path: "bank_statement_rule/expense_rules" },
      {
        name: "新增/修改付款规则",
        path: "bank_statement_rule/update_expense_rule",
      },
      {
        name: "查询匹配流水数据",
        path: "bank_statement_rule/expense_matched_statements",
      },
      {
        name: "修改付款规则状态",
        path: "bank_statement_rule/change_expense_status",
      },
      { name: "匹配流水", path: "bank_statement/match_rule" },
      { name: "查询收款规则", path: "bank_statement_rule/income_rules" },
      {
        name: "查询收款规则匹配流水",
        path: "bank_statement_rule/income_matched_statements",
      },
      {
        name: "修改收款规则状态",
        path: "bank_statement_rule/change_income_status",
      },
      {
        name: "新增/修改收款规则",
        path: "bank_statement_rule/update_income_rule",
      },
    ],
  },
  {
    routeName: ["流水相关", "现金余额表"],
    apiList: [
      { name: "查询树信息", path: "bank_balance_history/tree_info" },
      { name: "查询银行详情", path: "bank_balance_history/list" },
      { name: "查询理财分红记录", path: "dividend_record/list" },
      {
        name: "修改月初基金理财的其实余额",
        path: "bank_balance_setting/update",
      },
      { name: "更新分红记录", path: "dividend_record/update" },
      { name: "新增分红记录", path: "dividend_record/create" },
      { name: "删除分红记录", path: "dividend_record/delete" },
      { name: "查询余额", path: "bank_balance_setting/list" },
    ],
  },
  {
    routeName: ["流水相关", "现金余额"],
    apiList: [
      { name: "查询余额", path: "cash_balance/query_page" },
      { name: "导入余额", path: "cash_balance/import" },
      { name: "同步余额", path: "cash_balance/synchro_current_balance" },
    ],
  },
  {
    routeName: ["流水相关", "流水明细"],
    apiList: [],
  },
  {
    routeName: ["供应商管理"],
    apiList: [],
  },
  {
    routeName: ["供应商管理", "供应商列表"],
    apiList: [
      { name: "查询供应商列表", path: "payee_company/query" },
      { name: "查询商品电商项目", path: "product_type/leaf_info" },
      { name: "查询供应商", path: "payee_company/query_with_id" },
      { name: "修改供应商", path: "payee_company/update" },
    ],
  },
  {
    routeName: ["存货管理(财务)"],
    apiList: [],
  },
  {
    routeName: ["存货管理(财务)", "存货编码"],
    apiList: [
      { name: "查询存货单位", path: "stock_unit/get_all" },
      { name: "查询税码", path: "tax_code/query" },
      { name: "查询存货编码列表", path: "stock/es_query" },
      { name: "查询库存详情", path: "stock/detail" },
      { name: "查询出库信息", path: "stock/out_data" },
      { name: "查询日库存数据", path: "stock/inventory_data_daily" },
      { name: "查询库存合同", path: "stock/contracts" },
      { name: "修改库存", path: "stock/update" },
    ],
  },
  {
    routeName: ["存货管理(财务)", "存货编码", "导出按钮"],
    apiList: [{ name: "导出库存", path: "stock/export" }],
  },
  {
    routeName: ["存货管理(财务)", "税收编码"],
    apiList: [
      { name: "查询税率配置", path: "tax_rate/get_all" },
      { name: "查询税收编码", path: "tax_code/query" },
      { name: "修改税收编码", path: "tax_code/update" },
    ],
  },
  {
    routeName: ["存货管理(财务)", "采购合同"],
    apiList: [
      { name: "查询采购合同", path: "contract/es_query" },
      { name: "查询合同详情", path: "contract/detail" },
      { name: "查询合同相关信息", path: "expense_group/query_relate" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["存货管理(财务)", "电商类目管理"],
    apiList: [
      { name: "查询电商类目信息树", path: "product_type/tree_info" },
      { name: "更新电商类目", path: "product_type/update" },
      { name: "查询电商类目", path: "product_type/leaf_info" },
    ],
  },
  {
    routeName: ["存货管理(财务)", "入库清单"],
    apiList: [
      { name: "查询入库清单", path: "stock_in_record/query" },
      { name: "打印清单", path: "stock/stock_in_print" },
      { name: "修改入库", path: "stock_in_record/update" },
      { name: "入库详情", path: "stock_in_order/detail" },
      {
        name: "修改入库状态",
        path: "stock_in_order/query_contract_stock_status",
      },
      { name: "查询到达入库", path: "stock_in_record/arrived" },
    ],
  },
  {
    routeName: ["存货管理(财务)", "入库清单", "审核"],
    apiList: [{ name: "审核", path: "stock_in_record/audit" }],
  },
  {
    routeName: ["存货管理(财务)", "收发存汇总表"],
    apiList: [
      { name: "查询收发存汇总表", path: "stock_period_cost/query" },
      { name: "导入列表", path: "stock_period_cost/import" },
    ],
  },
  {
    routeName: ["存货管理(财务)", "仓库设置"],
    apiList: [
      { name: "查询仓库列表", path: "warehouse/all" },
      { name: "修改仓库", path: "warehouse/update" },
    ],
  },
  {
    routeName: ["电商管理"],
    apiList: [],
  },
  {
    routeName: ["电商管理", "存货上架"],
    apiList: [
      { name: "查询服务承诺配置", path: "mall_item/pledge_tags_list" },
      { name: "查询存货列表", path: "mall_item/es_query" },
      { name: "查询线上商品详情", path: "mall_item/online_item_detail" },
      { name: "查询线上商品编辑信息", path: "mall_item/online_item_edit_info" },
      { name: "更新存货", path: "mall_item/update" },
      { name: "查询更新内容", path: "mall_item/diff_info" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["进项发票", "发票清单"],
    apiList: [
      { name: "查询发票清单", path: "invoice/query" },
      { name: "发票详情", path: "invoice/detail" },
      { name: "查询最近添加的发票", path: "invoice/query_recent" },
      { name: "废弃发票", path: "invoice/delete" },
      { name: "认证发票地址", path: "invoice/ocr_invoice" },
      { name: "审核地址", path: "invoice/fill_in_by_xls" },
      { name: "更新发票", path: "invoice/update" },
      { name: "导入发票", path: "invoice/import_invoice" },
    ],
  },
  {
    routeName: ["进项发票", "发票清单", "打印导出面单"],
    apiList: [],
  },
  {
    routeName: ["进项发票", "发票清单", "审核按钮"],
    apiList: [{ name: "审核发票", path: "invoice/audit" }],
  },
  {
    routeName: ["进项发票", "发票导出"],
    apiList: [{ name: "导出", path: "export/invoice" }],
  },
  {
    routeName: ["进项发票", "发票生成"],
    apiList: [
      {
        name: "查询最近生成的发票数量",
        path: "invoice/query_recent_generate_invoice_number",
      },
    ],
  },
  {
    routeName: ["进项发票", "发票统计"],
    apiList: [
      {
        name: "查询发票统计信息",
        path: "expense_group/gen_invoice_statistic_data",
      },
      { name: "查询报销类统计", path: "expense_group/gen_bx_statistic_data" },
    ],
  },
  {
    routeName: ["进项发票", "无发票项配置"],
    apiList: [
      { name: "查询无发票项配置", path: "expense/query_non_invoice_expenses" },
    ],
  },
  {
    routeName: ["进项发票", "付款发票登记"],
    apiList: [{ name: "查询列表", path: "expense_register/query" }],
  },
  {
    routeName: ["进项发票", "报销发票登记"],
    apiList: [{ name: "查询列表", path: "expense_register/query" }],
  },
  {
    routeName: ["付款记录", "付款记录"],
    apiList: [{ name: "查询记录", path: "expense_payment_record/query" }],
  },
  {
    routeName: ["付款记录", "付款重试"],
    apiList: [
      { name: "查询重试记录", path: "expense_payment_record/query_repay" },
      { name: "重试支付", path: "expense_payment_record/repay" },
      { name: "废弃", path: "expense_payment_record/abandon" },
    ],
  },
  {
    routeName: ["流程状态", "实时情况"],
    apiList: [{ name: "查询实时状况", path: "flow/real_time_states" }],
  },
  {
    routeName: ["流程状态", "数据统计"],
    apiList: [
      { name: "查询流程状态", path: "flow_node_user/states" },
      { name: "查询流程列表", path: "flow/info_with_node_teams" },
      { name: "查询流程状态统计", path: "flow/states" },
    ],
  },
  {
    routeName: ["金蝶同步", "同步清单"],
    apiList: [
      { name: "查询同步列表", path: "kingdee_sync/query" },
      { name: "重试同步", path: "kingdee_sync/retry" },
      { name: "删除金蝶数据", path: "kingdee_sync/kingdee_del" },
      { name: "强制成功", path: "kingdee_sync/force_success" },
    ],
  },
  {
    routeName: ["金蝶同步", "发货单清单"],
    apiList: [
      { name: "查询发货单清单", path: "kingdee_sync/split_out_stock_query" },
      { name: "查询发货详情", path: "kingdee_sync/out_stock_detail" },
    ],
  },
  {
    routeName: ["团队管理", "实习生工资填写"],
    apiList: [
      { name: "查询我的实习生", path: "informal/my_informal" },
      { name: "查询津贴发放记录", path: "informal_wage_topic/list" },
      { name: "修改实习生主管", path: "informal/change_director" },
      { name: "修改日薪", path: "informal/change_daily_wage" },
      {
        name: "查询考勤信息",
        path: "hr/wxdata/financial/intern_salary_of_customer_new",
      },
      {
        name: "批量添加用户",
        path: "director_informal_wage_topic/batch_add_customer",
      },
      {
        name: "导入考勤记录",
        path: "director_informal_wage_topic/import_records",
      },
      { name: "查询我的非正式", path: "informal/my_informal" },
      {
        name: "查询非正式薪资记录",
        path: "director_informal_wage_topic/topic_record",
      },
      {
        name: "添加考勤记录",
        path: "director_informal_wage_topic/add_customer_to_wage_records",
      },
      { name: "取消工资发放", path: "informal_wage_record/delete" },
      { name: "主管放弃工资发放", path: "director_informal_wage_topic/delete" },
    ],
  },
  {
    routeName: ["团队管理", "实习生工资审核"],
    apiList: [
      { name: "查询记录", path: "director_informal_wage_topic/audit_topics" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["团队管理", "云账户月结工资审核"],
    apiList: [
      { name: "查询记录", path: "director_outsource_wage_topic/audit_topics" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["团队管理", "云账户月结工资填写"],
    apiList: [
      { name: "我的有效合同", path: "outsource_contract/my_valid_contract" },
      { name: "我的无效合同", path: "outsource_contract/my_expired_contract" },
      { name: "查询工资发放记录", path: "outsource_wage_topic/query" },
      {
        name: "负责人发放记录",
        path: "director_outsource_wage_topic/topic_record",
      },
      { name: "更新银行信息", path: "outsource_wage_record/update_bank_info" },
      {
        name: "更新云账户发放记录",
        path: "director_outsource_wage_topic/update_records",
      },
      {
        name: "更新记录状态",
        path: "director_outsource_wage_topic/update_status",
      },
      {
        name: "添加记录",
        path: "director_outsource_wage_topic/add_wage_record",
      },
      { name: "删除记录", path: "outsource_wage_record/delete" },
      { name: "放弃发放", path: "director_outsource_wage_topic/delete" },
      { name: "复原发放", path: "director_outsource_wage_topic/recover" },
    ],
  },
  {
    routeName: ["团队管理", "离职实习生工资发放"],
    apiList: [
      { name: "查询离职实习生工资列表", path: "dimission_wage/list" },
      { name: "修改", path: "dimission_wage/save" },
      { name: "删除", path: "dimission_wage/delete" },
      {
        name: "批量添加用户",
        path: "director_informal_wage_topic/batch_add_customer",
      },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["事件订阅", "订阅列表"],
    apiList: [
      { name: "查询订阅列表", path: "event_notice/query" },
      { name: "获取事件类型", path: "event_notice/event_types" },
      { name: "查询事件详情", path: "event_notice/detail" },
      { name: "修改事件", path: "event_notice/update" },
    ],
  },
  {
    routeName: ["权限管理", "群组"],
    apiList: [
      { name: "查询群组列表", path: "group/get_all" },
      { name: "群组详情", path: "group/detail" },
      { name: "删除群组用户", path: "group/delete_customer" },
      { name: "删除群组服务", path: "group/delete_service" },
      { name: "查询用户团队", path: "customer/query_with_team" },
      { name: "群组添加用户", path: "group/add_customer" },
      { name: "群组添加服务", path: "group/add_service" },
    ],
  },
  {
    routeName: ["权限管理", "服务"],
    apiList: [
      { name: "查询服务", path: "service/get_all" },
      { name: "编辑服务", path: "service/update" },
    ],
  },
  {
    routeName: ["MIS权限管理", "群组"],
    apiList: [
      { name: "查询MIS群组", path: "mis_group/get_all" },
      { name: "修改群组", path: "mis_group/update" },
      { name: "群组详情", path: "mis_group/detail" },
      { name: "群组添加用户", path: "mis_group/add_customer" },
      { name: "删除用户", path: "mis_group/delete_customer" },
    ],
  },
  {
    routeName: ["流程", "流程管理"],
    apiList: [
      { name: "查询流程", path: "flow/query" },
      { name: "更新流程", path: "flow/update" },
      { name: "修改流程状态", path: "flow/update_states" },
      { name: "更新统计数据", path: "flow/update_states" },
      { name: "修改流程钩子", path: "flow/update_hooks" },
      { name: "查询流程编辑信息", path: "flow/get_edit_info" },
      { name: "修改节点", path: "flow_node/update" },
      { name: "删除节点", path: "flow_node/delete" },
      { name: "删除边", path: "flow_edge/delete" },
      { name: "更新边", path: "flow_edge/update" },
      { name: "更新节点用户", path: "flow_node_user/update" },
      { name: "添加节点", path: "flow_node/new" },
      { name: "添加线条", path: "flow_edge/new" },
      { name: "节点添加用户", path: "flow_node/add_node_user" },
      { name: "查询用户", path: "customer/query_with_team" },
      { name: "修改节点通知", path: "flow_node/update_node_email" },
      {
        name: "修改节点是否需要统计",
        path: "flow_node/update_node_need_statistic",
      },
      { name: "修改节点团队", path: "flow_node/update_node_team" },
      { name: "修改节点颜色", path: "flow_node/update_node_color" },
      { name: "修改节点key名称", path: "flow_node/update_key_name" },
    ],
  },
  {
    routeName: ["流程", "流程转移"],
    apiList: [
      { name: "查询流程", path: "flow/query" },
      { name: "查询用户流程节点", path: "user_flow_node_user/query" },
      { name: "查询用户", path: "customer/query_with_team" },
      { name: "批量转移", path: "user_flow_node_user/batch_transfer" },
    ],
  },
  {
    routeName: ["其他", "办公室平面图"],
    apiList: [
      { name: "上传文件", path: "upload_to_oss_public" },
      { name: "平面图列表", path: "office_map/list" },
      { name: "修改平面图", path: "office_map/update" },
    ],
  },
  {
    routeName: ["开发者", "短信日志"],
    apiList: [
      { name: "查询短信日志", path: "sms_log/query" },
      { name: "重试发送", path: "sms_log/retry" },
    ],
  },
  {
    routeName: ["开发者", "邮件日志"],
    apiList: [
      { name: "查询邮件日志", path: "email_log/query" },
      { name: "重试发送", path: "sms_log/retry" },
    ],
  },
  {
    routeName: ["开发者", "操作日志"],
    apiList: [{ name: "查询操作日志", path: "commit_log/query" }],
  },
  {
    routeName: ["开发者", "mdi-icons"],
    apiList: [],
  },
  {
    routeName: ["开发者", "前端测试用"],
    apiList: [],
  },
  {
    routeName: ["开发者", "Sidekiq"],
    apiList: [],
  },
  {
    routeName: ["开发者", "金蝶API"],
    apiList: [],
  },
  {
    routeName: ["权限管理", "路由编辑"],
    apiList: [
      { name: "获取APP列表", path: "route_app/list" },
      { name: "更新APP列表", path: "route_app/update" },
      { name: "获取group列表", path: "route_group/all" },
      { name: "编辑group", path: "route_group/update" },
      { name: "获取人员列表", path: "route_group/customers" },
      { name: "新增群组人员", path: "route_group/add_customers" },
      { name: "删除群组人员", path: "route_group/del_customers" },
      { name: "获取APP menus", path: "route_app/detail" },
      { name: "新增items", path: "route_group/edit_app_route_menu_items" },
      { name: "获取route列表", path: "route_group/route_apps" },
      {
        name: "获取该组已选择的权限",
        path: "route_group/app_route_menu_items",
      },
    ],
  },
  {
    routeName: ["权限管理", "路由编辑", "app路由管理"],
    apiList: [],
  },
  {
    routeName: ["权限管理", "组群管理"],
    apiList: [
      { name: "获取group列表", path: "route_group/all" },
      { name: "编辑group", path: "route_group/update" },
      { name: "获取人员列表", path: "route_group/customers" },
      { name: "新增群组人员", path: "route_group/add_customers" },
      { name: "删除群组人员", path: "route_group/del_customers" },
      { name: "新增items", path: "route_group/edit_app_route_menu_items" },
      { name: "获取route列表", path: "route_group/route_apps" },
      {
        name: "获取该组已选择的权限",
        path: "route_group/app_route_menu_items",
      },
    ],
  },
  {
    routeName: ["权限管理", "组群管理", "组群管理详情"],
    apiList: [],
  },
  {
    routeName: ["iframe测试", "第一个页面"],
    apiList: [],
  },
  {
    routeName: ["iframe测试", "第二个页面"],
    apiList: [],
  },
  {
    routeName: ["线下发货", "发货列表"],
    apiList: [
      { name: "上传发货信息", path: "offline_order/import_batch_path" },
      { name: "查询线下发货订单", path: "offline_order/es_query_mine" },
      { name: "关闭线下发货单", path: "offline_order/close" },
      { name: "批量关闭", path: "offline_order/close_batch" },
      { name: "新增发货单", path: "offline_order/add_apply_offline_order" },
      { name: "导出发货单", path: "offline_order/export_offline_order" },
      { name: "获取统一团队列表", path: "offline_order/get_unified_team_list" },
      { name: "查询发货单详情", path: "offline_order/detail" },
    ],
  },
  {
    routeName: ["法务", "资质管理"],
    apiList: [
      { name: "查询主体列表", path: "qualification/subject_list" },
      { name: "查询资质列表", path: "qualification/item_list" },
      { name: "资质地址", path: "qualification/file_url" },
      { name: "查询历史版本", path: "qualification/histories_versions" },
      { name: "切换资质状态", path: "qualification/change_status" },
      { name: "更新资质", path: "qualification/update" },
      { name: "切换主体状态", path: "qualification/change_subject_status" },
      { name: "更新主体", path: "qualification/update_subject" },
    ],
  },
  {
    routeName: ["法务", "资质申请"],
    apiList: [
      { name: "查询资质申请列表", path: "qualification_order/list" },
      { name: "上传文件", path: "qualification_order/upload_stamped_file" },
      { name: "获取文件地址", path: "qualification/file_url" },
      {
        name: "下载完成的URL",
        path: "qualification_order/download_finished_url",
      },
      {
        name: "查询申请资质列表",
        path: "qualification_order/qualification_list",
      },
      { name: "新增申请", path: "qualification_order/create" },
      { name: "更新申请", path: "qualification_order/update" },
      { name: "删除申请", path: "qualification_order/delete" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["法务", "我的资质申请"],
    apiList: [
      { name: "查询我的申请", path: "qualification_order/mine_list" },
      ...flowBasicApiList,
    ],
  },
  {
    routeName: ["财务分析组", "团队分配"],
    apiList: [
      { name: "查询团队分配", path: "team_fin_customer/list" },
      { name: "修改", path: "team_fin_customer/update" },
    ],
  },
  {
    routeName: ["企业微信消息", "群发消息"],
    apiList: [
      { name: "添加群发", path: "group_send_message/add" },
      { name: "群发列表", path: "group_send_message/list" },
      { name: "获取群组", path: "route_group/all" },
      { name: "查询群组用户", path: "route_group/customers" },
    ],
  },
  {
    routeName: ["投放费用管理", "博主管理"],
    apiList: [
      { name: "owner查询博主", path: "placing_ads_kol/owner_query" },
      { name: "查询博主", path: "placing_ads_kol/query" },
      { name: "删除博主", path: "placing_ads_kol/delete" },
      { name: "导出", path: "placing_ads_kol/export" },
      { name: "修改博主", path: "placing_ads_kol/save" },
      { name: "标记风险", path: "placing_ads_kol/mark_risk_kol" },
      { name: "查询配置", path: "enum_config/list" },
    ],
  },
  {
    routeName: ["投放费用管理", "博主管理", "博主详情"],
    apiList: [],
  },
  {
    routeName: ["投放费用管理", "博主资源库"],
    apiList: [
      { name: "申请验证码", path: "placing_ads_kol_decrypt_auth_code/apply" },
      {
        name: "验证码验证",
        path: "placing_ads_kol_decrypt_auth_code/check_and_decrypt",
      },
      { name: "添加分享", path: "placing_ads_kol/add_enjoy_customer" },
      { name: "删除分享", path: "placing_ads_kol/delete_enjoy_customer" },
      { name: "查询博主详情", path: "placing_ads_kol/detail" },
    ],
  },
  {
    routeName: ["投放费用管理", "博主资源库", "博主详情"],
    apiList: [],
  },
  {
    routeName: ["投放费用管理", "投放记录"],
    apiList: [
      { name: "查询博主", path: "placing_ads_kol/query" },
      { name: "修改投放记录", path: "placing_ads_record/save" },
      { name: "查询投放记录", path: "placing_ads_record/query" },
      { name: "查询投放记录详情", path: "placing_ads_record/detail" },
      { name: "保存投放vas记录", path: "placing_ads_vas_record/save" },
      { name: "删除投放vas记录", path: "placing_ads_vas_record/delete" },
      { name: "删除投放记录", path: "placing_ads_record/delete" },
      { name: "导出投放记录", path: "placing_ads_record/export" },
      { name: "导入投放记录", path: "placing_ads_record/import" },
      { name: "导出投放", path: "placing_ads_kol/export" },
      { name: "废弃投放", path: "placing_ads_record/close" },
    ],
  },
  {
    routeName: ["投放费用管理", "投放记录", "同组编辑按钮权限"],
    apiList: [],
  },
  {
    routeName: ["投放费用管理", "投放配置"],
    apiList: [
      { name: "查询sku列表", path: "placing_ads_sku/list" },
      { name: "查询sku", path: "placing_ads_sku/all" },
      { name: "修改sku", path: "placing_ads_sku/save" },
      { name: "改变sku状态", path: "placing_ads_sku/change_status" },
      { name: "查询配置", path: "enum_config/list" },
      { name: "添加配置", path: "enum_config/add" },
      { name: "更新配置", path: "enum_config/update" },
      { name: "更改状态", path: "enum_config/change_status" },
    ],
  },
  {
    routeName: ["投放费用管理", "投放配置", "编辑/删除/新增按钮"],
    apiList: [],
  },
  {
    routeName: ["投放费用管理", "博主信息采集"],
    apiList: [
      { name: "查询博主合同", path: "kol_contract_info/search" },
      { name: "提供合同信息", path: "kol_contract_info/supply_contract_info" },
      {
        name: "创建外部合同",
        path: "kol_contract_info/create_outsource_contract",
      },
    ],
  },
  {
    routeName: ["投放费用管理", "博主信息采集", "博主详情"],
    apiList: [],
  },
  {
    routeName: ["投放费用管理", "账号管理"],
    apiList: [],
  },
  {
    routeName: ["投放费用管理", "账号管理", "导入数据权限"],
    apiList: [],
  },
];

export default {
  apiConfig: apiConfig,
  async initApi() {
    const connector = "$$";
    // 查询当前树
    const tree = await getAppDetailApi({ id: 1 });
    const res = [];
    const queue = [];
    // 已存在的API
    const existApi = [];
    // 遍历所有的页面节点和叶子节点
    const dfs = (node) => {
      if (node.route_type === "api" && !node.del) {
        const nameStr = queue
          .slice()
          .map((q) => q.name)
          .join(connector);
        if (
          !existApi.some(
            (api) => api.path === node.path && nameStr === api.nameStr
          )
        ) {
          existApi.push({
            nameStr: nameStr,
            path: node.path,
          });
        }
        return;
      }
      if (node.del) {
        return;
      }
      queue.push(node);
      // 页面节点
      if (node.route_type === "default" && node.path !== "") {
        res.push({
          id: node.id,
          nameArr: queue.slice().map((q) => q.name),
        });
        if (node.items && Array.isArray(node.items) && node.items.length > 0) {
          for (const item of node.items) {
            dfs(item);
          }
        }
      } else {
        if (node.items && Array.isArray(node.items) && node.items.length > 0) {
          for (const item of node.items) {
            dfs(item);
          }
        } else {
          // 叶子节点
          res.push({
            id: node.id,
            nameArr: queue.slice().map((q) => q.name),
          });
        }
      }
      queue.pop();
    };
    for (const item of tree.app.items) {
      dfs(item);
    }
    console.log(
      res.map((item) => {
        return {
          routeName: item.nameArr,
          apiList: [],
        };
      })
    );
    // 组装数据
    const assemble = res.map((item) => {
      const index = this.apiConfig.findIndex(
        (one) => one.routeName.join(connector) === item.nameArr.join(connector)
      );
      if (index >= 0) {
        return {
          ...item,
          api: this.apiConfig[index].apiList,
        };
      } else {
        return {
          ...item,
          api: [],
        };
      }
    });
    // console.log(assemble.map())
    const needAdd = assemble.filter((item) => item.api.length > 0);
    let finished = 0;
    let errCnt = 0;
    const total = needAdd.reduce((prev, cur) => {
      return prev + cur.api.length;
    }, 0);
    console.log(needAdd);
    const needCnt = [];
    for (const add of needAdd) {
      for (const api of add.api) {
        try {
          if (
            !existApi.some(
              (item) =>
                item.path === api.path &&
                item.nameStr === add.nameArr.join(connector)
            )
          ) {
            const params = {
              name: api.name,
              auth_key: "",
              parent_id: add.id,
              pinyin: "",
              icon: "",
              route_type: "api",
              path: api.path.trim(),
              red_dot_token: "",
              pb_workspace_id: "",
              pb_report_id: "",
              is_public: false,
              is_formal: false,
              is_team_leader: false,
              del: false,
              route_app_id: 1,
            };
            console.log(params);
            needCnt.push({
              name: add.nameArr.join(connector),
              path: api,
            });
            await updateRouterApi(params);
          }
        } catch (e) {
          errCnt++;
          console.log("添加错误", api.path);
        }
        finished++;
        console.log(
          `finished ${finished}/${total}, error ${errCnt}, process ${Math.round(
            (finished / total) * 100
          )}%`
        );
      }
    }
    console.log("需要增加的API", needCnt);
  },
  getApiFlatList: () => {
    console.log(this);
    const set = new Set();
    apiConfig.forEach((element) => {
      element.apiList.forEach((api) => {
        set.add(api.path);
      });
    });
    return Array.from(set);
  },
};
